const Spinner = () => {
  return(
    <div className="text-center mt-5">
      <div className="spinner-border text-info text-center"></div>
    </div>
  );
};

export default Spinner;